<a [routerLink]="isAlreadyOnRoute ? null : [href]" [queryParams]="queryParams" [ngClass]="isSubItem ? 'sub-navigation-link' : 'navigation-link'" [class.active]="isActive">
    <div class="d-flex align-items-center">
        <div class="icon-status-wrapper" *ngIf="showText">
            <ng-content select="[iconStatus]"></ng-content>
        </div>
        <span *ngIf="showValidationStatus" title="{{'validation-tooltip' | translate}}" [ngClass]="{ 'validation-icon-lg': true, 'validation-icon-sm': ! showText, 'hidden': !showText && isSubItem }" [attr.valid]="isValid"></span>
        <div class="d-flex flex-column">
            <div [ngClass]="[isSubItem ? 'sub-navigation-text' : 'navigation-text', !showText ? 'hidden' : '']" [attr.aria-label]="GetLocalizedName" >
                <div *ngIf="isSubItem" class="d-flex align-items-center">
                    <div class="sub-item-connector"></div>
                    {{ GetLocalizedName }}
                </div>
                <div *ngIf="!isSubItem">
                    {{ GetLocalizedName }}
                </div>
            </div>
        </div>
    </div>
</a>
<ng-content select="[group]"></ng-content>